module.exports = __webpack_public_path__ + "static/felices-f9cfd057418e3907a73031e6876bd6be.png";